/* 🤖 this file was generated by svg-to-ts */
export const matIconFastfood: {
  name: 'fastfood';
  data: string;
} = {
  name: 'fastfood',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M1 21.98c0 .56.45 1.01 1.01 1.01H15c.56 0 1.01-.45 1.01-1.01V21H1v.98zM8.5 8.99C4.75 8.99 1 11 1 15h15c0-4-3.75-6.01-7.5-6.01zM3.62 13c1.11-1.55 3.47-2.01 4.88-2.01s3.77.46 4.88 2.01H3.62zM1 17h15v2H1zM18 5V1h-2v4h-5l.23 2h9.56l-1.4 14H18v2h1.72c.84 0 1.53-.65 1.63-1.47L23 5h-5z"/></svg>`
};
